function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 10 18.728 C 14.82 18.728 18.728 14.82 18.728 10 C 18.728 5.18 14.82 1.272 10 1.272 C 5.18 1.272 1.272 5.18 1.272 10 C 1.272 14.82 5.18 18.728 10 18.728 Z M 6.878 5.849 C 6.594 5.565 6.134 5.565 5.849 5.849 C 5.565 6.134 5.565 6.594 5.849 6.878 L 8.971 10 L 5.849 13.122 C 5.565 13.406 5.565 13.867 5.849 14.151 C 6.134 14.435 6.594 14.435 6.878 14.151 L 10 11.029 L 13.122 14.151 C 13.406 14.435 13.867 14.435 14.151 14.151 C 14.435 13.867 14.435 13.406 14.151 13.122 L 11.029 10 L 14.151 6.878 C 14.435 6.594 14.435 6.134 14.151 5.849 C 13.867 5.565 13.406 5.565 13.122 5.849 L 10 8.971 L 6.878 5.849 Z",
    fill: "currentColor",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.d90a6dc1a8c9a7ebcabd223f3a63fbf5.svg";
export { ForwardRef as ReactComponent };